import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import { login,userLogout } from '@/api/employee'
import { getToken, setToken, removeToken,getStoreId, setStoreId, removeStoreId, setUserInfo, getUserInfo, removeUserInfo } from '@/utils/cookies'
import store from '@/store'
import Cookies from 'js-cookie'
import { Message } from 'element-ui'

function readUserInfoCookie(): any {
  try {
    const raw = Cookies.get('user_info')
    if (raw) return typeof raw === 'string' ? JSON.parse(raw) : raw
  } catch (_) {
    /* ignore */
  }
  return {}
}

export interface IUserState {
  token: string
  name: string
  avatar: string
  storeId: string
  introduction: string
  userInfo: any
  roles: string[]
  username: string
}

@Module({ 'dynamic': true, store, 'name': 'user' })
class User extends VuexModule implements IUserState {
  public token = getToken() || ''
  public name = ''
  public avatar = ''
  // @ts-ignore
  public storeId: string = getStoreId() || ''
  public introduction = ''
  public userInfo = {}
  public roles: string[] = []
  public username = Cookies.get('username') || ''

  @Mutation
  private SET_TOKEN(token: string) {
    this.token = token
  }

  @Mutation
  private SET_NAME(name: string) {
    this.name = name
  }

  @Mutation
  private SET_USERINFO(userInfo: any) {
    this.userInfo = { ...userInfo }
  }

  @Mutation
  private SET_AVATAR(avatar: string) {
    this.avatar = avatar
  }

  @Mutation
  private SET_INTRODUCTION(introduction: string) {
    this.introduction = introduction
  }

  @Mutation
  private SET_ROLES(roles: string[]) {
    this.roles = roles
  }

  @Mutation
  private SET_STOREID(storeId: string) {
    this.storeId = storeId
  }
  @Mutation
  private SET_USERNAME(name: string) {
    this.username = name
    }

  @Action
  public async Login(userInfo: { username: string, password: string }) {
    let { username, password } = userInfo
    username = username.trim()
    this.SET_USERNAME(username)
    Cookies.set('username', username)
    const { data } = await login({ username, password })
    if (String(data.code) === '1') {
      this.SET_TOKEN(data.data.token)
      setToken(data.data.token)
      this.SET_USERINFO(data.data)
      Cookies.set('user_info', data.data)
      // 店长登录：锁定本店，无需再选商户
      if (data.data.lockedStore && data.data.storeId != null) {
        const sid = String(data.data.storeId)
        this.SET_STOREID(sid)
        setStoreId(sid)
      }
      return data
    } else {
      return Message.error(data.msg)
    }
  }

  @Action
  public ResetToken () {
    removeToken()
    this.SET_TOKEN('')
    this.SET_ROLES([])
  }

  @Action
  public async changeStore(data: any) {
    this.SET_STOREID(data.data)
    this.SET_TOKEN(data.authorization)
    setStoreId(data.data)
    setToken(data.authorization)
  }

  @Action
  public SetStore(id: string) {
    this.SET_STOREID(id)
    setStoreId(id)
  }

  @Action
  public async GetUserInfo () {
    if (this.token === '') {
      throw Error('GetUserInfo: token is undefined!')
    }

    const data = JSON.parse(<string>getUserInfo()) //  { roles: ['admin'], name: 'zhangsan', avatar: '/login', introduction: '' }
    if (!data) {
      throw Error('Verification failed, please Login again.')
    }

    const { roles, name, avatar, introduction, applicant, storeManagerName, storeId='' } = data // data.user
    // roles must be a non-empty array
    if (!roles || roles.length <= 0) {
      throw Error('GetUserInfo: roles must be a non-null array!')
    }

    this.SET_ROLES(roles)
    this.SET_USERINFO(data)
    this.SET_NAME(name || applicant || storeManagerName)
    this.SET_AVATAR(avatar)
    this.SET_INTRODUCTION(introduction)
  }

  @Action
  public async LogOut () {
    const { data } = await userLogout({})
    removeToken()
    removeStoreId()
    this.SET_TOKEN('')
    this.SET_STOREID('')
    this.SET_ROLES([])
    Cookies.remove('username')
    Cookies.remove('user_info')
    removeUserInfo()
  }

  @Action
  public ClearStore () {
    removeStoreId()
    this.SET_STOREID('')
  }

  /** 是否店长且锁定本店 */
  get isStoreLocked(): boolean {
    const info: any =
      this.userInfo && Object.keys(this.userInfo as any).length
        ? this.userInfo
        : readUserInfoCookie()
    if (info.lockedStore === true) return true
    return Number(info.role) === 1 && info.storeId != null
  }

  get isSuperAdmin(): boolean {
    const info: any =
      this.userInfo && Object.keys(this.userInfo as any).length
        ? this.userInfo
        : readUserInfoCookie()
    if (Number(info.role) === 0) return true
    const name = info.userName || info.username || this.username
    return !!(name && String(name).toLowerCase() === 'admin')
  }

  /** 更新本地缓存的姓名/手机号/邮箱（修改个人信息后） */
  @Action
  public UpdateProfileInfo(payload: { name: string, phone?: string, email?: string }) {
    const prev = { ...(this.userInfo as any) }
    const next = {
      ...prev,
      name: payload.name,
      phone: payload.phone != null ? payload.phone : prev.phone,
      email: payload.email != null ? payload.email : prev.email
    }
    this.SET_USERINFO(next)
    this.SET_NAME(payload.name || '')
    Cookies.set('user_info', next)
  }
}

export const UserModule = getModule(User)
